// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--IVxEQ","title":"_80ad21f8ef--title--Gj6df","description":"_80ad21f8ef--description--3utDD","footer":"_80ad21f8ef--footer--3csIw"};